import {PROCUREMENT_PERMS, ProcurementPermissionCode} from './permissions'

type CanFn = (permissionCode: ProcurementPermissionCode | string) => boolean

/**
 * Library read access (list/view). Independent from MANAGE and CRUD action permissions.
 */
export const libraryViewAccess = {
  category: (can: CanFn) => can(PROCUREMENT_PERMS.READ_LIBRARY_CATEGORY),
  head: (can: CanFn) => can(PROCUREMENT_PERMS.LIBRARY_HEAD_VIEW),
  subHead: (can: CanFn) => can(PROCUREMENT_PERMS.LIBRARY_SUBHEAD_VIEW),
  subCategory: (can: CanFn) => can(PROCUREMENT_PERMS.LIBRARY_SUBCATEGORY_VIEW),
  address: (can: CanFn) => can(PROCUREMENT_PERMS.LIBRARY_ADDRESS_VIEW),
  terms: (can: CanFn) => can(PROCUREMENT_PERMS.READ_TERMS_CONDITIONS_LIBRARY),
  accounting: (can: CanFn) => can(PROCUREMENT_PERMS.LIBRARY_ACCOUNTING_VIEW),
  subAccounting: (can: CanFn) => can(PROCUREMENT_PERMS.LIBRARY_SUBACCOUNTING_VIEW),
}

/**
 * Management-screen / non-CRUD library access. Does not imply CREATE, UPDATE, or DELETE.
 */
export const libraryManageAccess = {
  category: (can: CanFn) =>
    can(PROCUREMENT_PERMS.CREATE_LIBRARY_CATEGORY) ||
    can(PROCUREMENT_PERMS.UPDATE_LIBRARY_CATEGORY) ||
    can(PROCUREMENT_PERMS.DELETE_LIBRARY_CATEGORY),
  head: (can: CanFn) => can(PROCUREMENT_PERMS.LIBRARY_HEAD_MANAGE),
  subHead: (can: CanFn) => can(PROCUREMENT_PERMS.LIBRARY_SUBHEAD_MANAGE),
  subCategory: (can: CanFn) => can(PROCUREMENT_PERMS.LIBRARY_SUBCATEGORY_MANAGE),
  address: (can: CanFn) => can(PROCUREMENT_PERMS.LIBRARY_ADDRESS_MANAGE),
  terms: (can: CanFn) =>
    can(PROCUREMENT_PERMS.CREATE_TERMS_CONDITIONS_LIBRARY) ||
    can(PROCUREMENT_PERMS.UPDATE_TERMS_CONDITIONS_LIBRARY) ||
    can(PROCUREMENT_PERMS.DELETE_TERMS_CONDITIONS_LIBRARY),
  accounting: (can: CanFn) => can(PROCUREMENT_PERMS.LIBRARY_ACCOUNTING_MANAGE),
  subAccounting: (can: CanFn) => can(PROCUREMENT_PERMS.LIBRARY_SUBACCOUNTING_MANAGE),
}

/** Independent library row actions — MANAGE must not grant these. */
export const libraryCrudAccess = {
  category: {
    create: (can: CanFn) => can(PROCUREMENT_PERMS.CREATE_LIBRARY_CATEGORY),
    update: (can: CanFn) => can(PROCUREMENT_PERMS.UPDATE_LIBRARY_CATEGORY),
    delete: (can: CanFn) => can(PROCUREMENT_PERMS.DELETE_LIBRARY_CATEGORY),
  },
  terms: {
    create: (can: CanFn) => can(PROCUREMENT_PERMS.CREATE_TERMS_CONDITIONS_LIBRARY),
    update: (can: CanFn) => can(PROCUREMENT_PERMS.UPDATE_TERMS_CONDITIONS_LIBRARY),
    delete: (can: CanFn) => can(PROCUREMENT_PERMS.DELETE_TERMS_CONDITIONS_LIBRARY),
  },
}
